import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';

interface ArchiveInvoiceInput {
    invoiceId?: string;
    invoiceIds?: string[];
    archived?: boolean;
}

const archiveInvoice = async (data: ArchiveInvoiceInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/invoice/archive`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useArchiveInvoices = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: ArchiveInvoiceInput) => archiveInvoice(data, sessionContext?.sessionId ?? null),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['/invoices/feed'] });
            if (variables.invoiceId) {
                queryClient.invalidateQueries({ queryKey: ['/invoice/detail', variables.invoiceId] });
                queryClient.invalidateQueries({ queryKey: ['/invoice/activity-logs', variables.invoiceId] });
            }
            if (variables.invoiceIds?.length) {
                for (const invoiceId of variables.invoiceIds) {
                    queryClient.invalidateQueries({ queryKey: ['/invoice/detail', invoiceId] });
                    queryClient.invalidateQueries({ queryKey: ['/invoice/activity-logs', invoiceId] });
                }
            }
        },
        onError: (error) => {
            console.error('Failed to archive invoice(s):', error);
        },
    });
};
